import { render, staticRenderFns } from "./Restaurants.vue?vue&type=template&id=6f18b784&scoped=true&"
import script from "./Restaurants.vue?vue&type=script&lang=js&"
export * from "./Restaurants.vue?vue&type=script&lang=js&"
import style0 from "./Restaurants.vue?vue&type=style&index=0&id=6f18b784&scoped=true&lang=css&"
import style1 from "./Restaurants.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f18b784",
  null
  
)

export default component.exports